/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Trans, translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import styles from '../../../../ActionDrawer.module.scss';

@translate()
@inject('actionDrawerStore')
@observer
export default class RemoveAssetFromProjectError extends React.Component<*> {
  render(): React.Node {
    const {
      t,
      actionDrawerStore,
      asset,
    }: {
      t: TranslatorProps,
      actionDrawerStore: TypeActionDrawerStore,
      asset: Object,
    } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <h3>{t('general:error')}</h3>
          <Trans i18nKey="general:assets.messages.not_removed_from_project" parent="p">
            <u>{t('general:not')}</u>
          </Trans>
          <ul>
            <li>
              <b>{t('general:assets.labels.number')}: </b>
              {asset.asset_number}
            </li>
            <li>
              <b>{t('general:manufacturer')}: </b>
              {asset.manufacturer}
            </li>
            <li>
              <b>{t('general:model')}: </b>
              {asset.model}
            </li>
          </ul>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            color="primary"
            variant="contained"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
